import '@styles/keyframes.css'
import '@styles/global.css'
import AccountManageSubscription from '@components/account_settings/AccountManageSubscription'
import ProvidersWithRouteAccess from './ProvidersWithRouteAccess'
import { useAuthContext } from '@contexts/authContext'
import { SocialProfile } from '@screens/SocialProfile'
import LayoutHOC from '@components/layout/LayoutHOC'
import Notifications from '@screens/Notifications'
import Conversations from '@screens/Conversations'
import PasswordReset from '@screens/PasswordReset'
import Subscription from '@screens/Subscription'
import Protect from '@components/auth/Protect'
import NearbyGrid from '@screens/NearbyGrid'
import PostShow from '@screens/PostShow'
import Settings from '@screens/Settings'
import Landing from '@screens/Landing'
import NoMatch from '@screens/NoMatch'
import Search from '@screens/Search'
import Nearby from '@screens/Nearby'
import About from '@screens/About'
import Home from '@screens/Home'
import {
  Route,
  BrowserRouter,
  Routes,
} from "react-router-dom"

///// ROUTING /////
const RoutesHOC = () => {
  const { authenticated } = useAuthContext()
  
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ProvidersWithRouteAccess><LayoutHOC /></ProvidersWithRouteAccess>}>
          <Route exact path="" element={<Protect>{authenticated ? <Nearby /> : <Landing />}</Protect>} />
          <Route exact path="landing" element={<Landing />} />
          <Route exact path="login" element={<Landing />} />
          <Route exact path="home" element={<Protect><Home /></Protect>} />
          <Route exact path="posts/:id" element={<Protect><PostShow /></Protect>} />
          <Route exact path="profiles/:id" element={<Protect><SocialProfile /></Protect>} />
          <Route exact path="map" element={<Protect><Nearby /></Protect>} />
          <Route exact path="grid" element={<Protect><NearbyGrid /></Protect>} />
          <Route exact path="notifications" element={<Protect><Notifications /></Protect>} />
          <Route exact path="conversations" element={<Protect><Conversations /></Protect>} />
          <Route exact path="search" element={<Protect><Search /></Protect>} />
          <Route exact path="settings" element={<Protect><Settings /></Protect>} />
          <Route exact path="settings/manage_subscription" element={<Protect><AccountManageSubscription /></Protect>} />
          <Route exact path="subscription" element={<Protect><Subscription /></Protect>} />
          <Route exact path="about" element={<About />} />
          <Route exact path="password_reset" element={<PasswordReset />} />
          <Route path="*" element={<NoMatch />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default RoutesHOC
